interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  tone?: "dark" | "light";
  align?: "center" | "left";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  tone = "dark",
  align = "center",
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div className={`flex flex-col ${alignment} gap-4`}>
      {eyebrow ? (
        <span
          className={`inline-flex items-center gap-3 font-label text-[0.7rem] font-medium uppercase tracking-[0.32em] ${
            isDark ? "text-accent-600" : "text-accent-400"
          }`}
        >
          <span className="h-px w-8 bg-accent-500/70" aria-hidden="true" />
          {eyebrow}
          <span className="h-px w-8 bg-accent-500/70" aria-hidden="true" />
        </span>
      ) : null}

      <h2
        className={`font-heading text-3xl font-semibold leading-[1.12] tracking-tight md:text-[2.6rem] ${
          isDark ? "text-foreground-950" : "text-background-50"
        }`}
      >
        {title}
      </h2>

      {description ? (
        <p
          className={`max-w-2xl font-body text-sm leading-relaxed md:text-base ${
            isDark ? "text-foreground-700" : "text-background-200"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}